import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import styles from "./ViewRulesetsPage.module.css";
import FilterRuleset from "Events/Components/FilterRuleset";
import RulesetList from "Events/Components/RulesetList";
import Header from "shared/Header";
import { useViewRulesetsPage } from "./useViewRulesetsPage";
import { useCurrentRoute } from "../../../../src/shared/@hooks/useCurrentRoute";
import Loader from "shared/Loader";

/**
 * A page under events page in options to view rulesets.
 */

export function ViewRulesetsPage() {
  let history = useHistory();

  // const { data, status, refetch, isLoading } = useViewRulesetsPage();
  const {
    rulesetData,
    rulesetStatus,
    refetchRulesetData,
    isRulesetDataLoading,
  } = useCurrentRoute();

  const [rulesetState, setRulesetState] = useState(undefined);
  const [ruleset, setRuleset] = useState(undefined);
  const [selectOptions, setSelectOptions] = useState({
    All: ["All"],
    Major: ["Major"],
    LOS: ["LOS"],
    Local: ["Local"],
    "Family Reunion": ["Family Reunion"],
  });

  const [eventOptions, setEventOptions] = useState(["All"]);

  useEffect(() => {
    if (rulesetData) {
      setRulesetState(rulesetData);

      // Use a Set to ensure unique event names
      const optionsSet = new Set(["All"]);

      rulesetData.forEach((item) => {
        item.events.forEach((event) => {
          optionsSet.add(event.name.toString());
        });
      });

      // Convert the Set back to an array for eventOptions
      setEventOptions(Array.from(optionsSet));
    }
  }, [rulesetData]);

  // FILTER
  const handleFiltering = (filter) => {
    let eventNameData = null;
    let searchData = null;
    let eventData = null;

    if (filter.ruleset && filter.ruleset !== "All") {
      eventNameData = rulesetData.filter((item) =>
        item.name.toLowerCase().includes(filter.ruleset.toLowerCase())
      );
    } else {
      eventNameData = rulesetData;
    }

    if (filter.search) {
      searchData = eventNameData.filter((item) => {
        const eventMatch = item.events.some((event) =>
          event.name.toLowerCase().includes(filter.search.toLowerCase())
        );
        return (
          item.name.toLowerCase().includes(filter.search.toLowerCase()) ||
          eventMatch
        );
      });
    } else {
      searchData = eventNameData;
    }

    if (filter.event && filter.event !== "All") {
      eventData = searchData.filter((item) =>
        item.events.some((event) =>
          event.name.toLowerCase().includes(filter.event.toLowerCase())
        )
      );
    } else {
      eventData = searchData;
    }

    setRulesetState(eventData);

    const optionsSet = new Set(["All"]);
    eventNameData.forEach((item) => {
      item.events.forEach((event) => optionsSet.add(event.name.toString()));
    });

    setEventOptions(Array.from(optionsSet));
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.title}>
            <Header title={"VIEW RULESETS"} onClick={() => history.goBack()} />
          </div>

          <div className={styles.filterRuleset}>
            <FilterRuleset
              onClick={handleFiltering}
              rulesetData={selectOptions}
              eventOptions={eventOptions}
              setRuleset={(selection) => setRuleset(selection)}
            />
          </div>

          <div className={styles.rulesetHeader}>
            <div>RULESET</div>
          </div>
        </div>

        <div className={styles.rulesetList}>
          {rulesetState && <RulesetList rulesets={rulesetState} />}
          {isRulesetDataLoading && <Loader />}
        </div>
      </div>
    </>
  );
}

ViewRulesetsPage.propTypes = {};
